import { type PropsWithChildren, type Dispatch, type SetStateAction } from 'react';
import { MenuTrigger, Popover } from 'react-aria-components';
import { FilterButton } from '@repo/design-system-kit';
import type { PropertyOption } from '../../../types';
import styles from './filters-list-item.module.css';

export interface FiltersListItemProps {
  autoOpen?: boolean;
  values?: string[];
  onClose?: () => void;
}

export interface FilterListItemComponentProps {
  filter: PropertyOption;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  values?: string[];
  isActive?: boolean;

  onClose?: () => void;
  onClear?: () => void;
}

export function FiltersListItem({
  filter,
  open,
  setOpen,
  values = [],
  isActive = false,
  onClose,
  children,
  onClear,
}: PropsWithChildren<FilterListItemComponentProps>) {
  function handleOpenChange(next: boolean) {
    setOpen(next);
    if (!next) onClose?.();
  }

  return (
    <MenuTrigger isOpen={open} onOpenChange={handleOpenChange}>
      <FilterButton
        className={styles.filterButton}
        data-filter-key={filter.key}
        data-testid="filter-button"
        isActive={isActive}
        key={filter.key}
        onClear={onClear}
      >
        <span className={styles.filterButtonLabel}>
          {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx -- Colon is a separator, not a translatable string */}
          {values.length ? `${filter.label}: ${values.join(', ')}` : filter.label}
        </span>
      </FilterButton>
      <Popover className={styles.dropdown}>{children}</Popover>
    </MenuTrigger>
  );
}
